// Import Sentry FIRST before any other imports
import * as Sentry from "@sentry/react";

const environment = import.meta.env.MODE || 'development';
const sentryDsn ="https://88ae124a22e94265e15ce9e3ab89ae47@o4510509662666752.ingest.us.sentry.io/4510509808549888";

console.log('🔧 Initializing Sentry (Frontend)...');
console.log('   Environment:', environment);
console.log('   DSN:', sentryDsn);
console.log('   Using env var:', !!import.meta.env.VITE_SENTRY_DSN);

Sentry.init({
  dsn: sentryDsn,
  
  // Environment configuration
  environment: environment,
  
  // Enable Sentry in all environments
  enabled: true,
  
  // Debug mode - set to true to see console logs
  // debug: environment === 'development',
  
  // Performance Monitoring
  integrations: [
    // Browser tracing for performance monitoring
    Sentry.browserTracingIntegration(),
    
    // Replay integration for session replay
    Sentry.replayIntegration({
      // Session Replay configuration
      maskAllText: false, // Set to true in production to mask all text
      blockAllMedia: false, // Set to true in production to block all media
    }),
  ],
  
  // Sample rate for error events (1.0 = 100% of errors)
  sampleRate: 1.0,
  
  // Performance monitoring sample rate
  tracesSampleRate: environment === 'production' ? 0.1 : 1.0, // 100% in dev, 10% in prod
  
  // Session Replay sample rate
  replaysSessionSampleRate: 0.1, // 10% of normal sessions
  replaysOnErrorSampleRate: 1.0, // 100% of sessions with errors
  
  // Release tracking (optional)
  release: import.meta.env.VITE_APP_VERSION || 'development',
  
  // beforeSend hook for debugging and filtering
  beforeSend(event, _) {
    // Always log to console when an event is being sent (in development)
    if (environment === 'development') {
      console.log('\n🔴 ============================================');
      console.log('🔴 SENTRY EVENT BEING SENT (FRONTEND)');
      console.log('🔴 ============================================');
      console.log('   Message:', event.message || 'No message');
      console.log('   Exception:', event.exception?.values?.[0]?.value || 'No exception');
      console.log('   Level:', event.level);
      console.log('   Environment:', event.environment);
      console.log('   Event ID:', event.event_id);
      console.log('   URL:', event.request?.url);
      console.log('🔴 ============================================\n');
    }
    
    return event;
  },
  
  // Ignore certain errors (optional)
  ignoreErrors: [
    // Browser extensions
    'top.GLOBALS',
    // Random plugins/extensions
    'originalCreateNotification',
    'canvas.contentDocument',
    'MyApp_RemoveAllHighlights',
    // Facebook SDK
    'fb_xd_fragment',
    // Avast extension errors
    '_avast_submit',
  ],
});

console.log('✅ Sentry (Frontend) initialized successfully');


